import MemberPage from './MemberPage';
import { MemberDetail } from './MemberDetail';

export {
    MemberPage,
    MemberDetail,
}


// WEBPACK FOOTER //
// src/client/components/site/features/members/pages/index.js